<template>
<div class="board">
  <div class="title">{{title}}</div>
  <div ref="tick" class="tick" style="display: inline-block">
    <div data-repeat="true" aria-hidden="true" :style="{'font-size': fontSize}">
      <span class="fit-flip" data-view="flip"></span>
    </div>
  </div>
  <span class="unit">{{unit}}</span>
</div>
</template>

<script>
import Tick from "@pqina/flip";

export default {
  name: "ScoreBoard",
  props: {
    title: { type: String },
    unit: { type: String },
    fontSize: { type: String, default: '6vh' },
    value: { type: [Number,String] },
    minLength: { type: Number, default: null },
  },
  data() {
    return {
      // value: 100,
    }
  },
  watch: {
    value(newValue) {
      if(!newValue) return
      this._tick.value = this.valueToStr(newValue)
    }
  },
  methods: {
    valueToStr(value) {
      if (!value) return 0

      if (!this.minLength) {
        return value
      }
      return value.toString().padStart(this.minLength, '0')
    }
  },
  mounted() {
    this._tick = Tick.DOM.create(this.$refs.tick, {
      value: this.valueToStr(this.value),
      'background-color': 'red'
    });
    // setInterval(() => {
    //   if (this.value) {
    //     this._tick.value = this.value.toString().padStart(5, '0');
    //   }
    // },10)
  },
  destroyed() {
    Tick.DOM.destroy(this.$refs.tick);
  },
}
</script>
<style>
/*.fit-flip .tick-flip-panel {*/
/*  background: #e74a23;*/
/*}*/
</style>
<style scoped>
.board {
  background: linear-gradient(140deg,rgba(255,255,255,0.9),rgba(255,255,255,0.85),rgba(255,255,255,0.95));
  /*padding: 2vh 4vh 4vh 4vh;*/
  padding: 1vh;
  border: 4px solid #e74a23;
  border-radius: 8px;
  box-shadow: 1vh 1vh 2vh rgba(0,0,0,0.5);
  box-sizing: content-box;
  width: fit-content;
  z-index: 9999;
  display: inline-block;
}
.title {
  /*background: #e74a23;*/
  border-radius: 4px;
  color: #e74a23;
  /*color: #f0f0f0;*/
  font-weight: bold;
  font-size: 2vh;
  margin-bottom: 2px;
  text-align: center;
}
.unit {
  /*margin: 0;*/
  border-radius: 2px;
  /*background: #e74a23;*/
  color: #e74a23;
  padding: 0.5vh;
  font-weight: bold;
  font-size: 3vh;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ScoreBoard.vue